<template>
  <div class="shipping-create h-100" style="position: relative;">
      <b-col id="shipping-form">
        <create-from-item :new-shipping="shipping" @success="emitSuccess" @place-selected="setPlace" />
      </b-col>
      <b-col class="d-none d-md-block" id="shipping-map">
        <leaflet-map ref="fullMap" :fitAlways="true" :geolocate="false" />
      </b-col>
  </div>
</template>

<script>
import LeafletMap from '@/components/Maps/LeafletMap'
import CreateFromItem from './CreateFromItem'
export default {
  name: 'CompanyNewShipping',
  components: {
    LeafletMap,
    CreateFromItem
  },
  data() {
    return {
      shipping: {
        scheduledDate: null,
        currency: 'ARS',
        type: 'regular',
        flow: 'semi-automatic',
        from: {
          placeId: '',
          street: '',
          number: null,
          floor: '',
          apartment: '',
          city: '',
          state: '',
          postalCode: '',
          country: 'AR',
          instructions: '',
          contact: {
            firstName: '',
            lastName: '',
            email: '',
            phone: ''
          },
          message: '',
          lat: null,
          lng: null,
          coords: {}
        },
        to: {
          placeId: '',
          street: '',
          number: null,
          floor: '',
          apartment: '',
          city: '',
          state: '',
          postalCode: '',
          country: 'AR',
          instructions: '',
          contact: {
            firstName: '',
            lastName: '',
            email: '',
            phone: ''
          },
          message: '',
          googlePlaceString: '',
          lat: null,
          lng: null,
          coords: {}
        },
        internalCode: '',
        description: '',
        sizeId: 1,
        extra: {},
        conf: {
          extraCheckpoints: {
            beforePickup: [],
            beforeDelivery: []
          }
        },
        settings: []
      },
      markers: []
    }
  },
  methods: {
    emitSuccess() {
      this.$emit('success')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
    setPlace(coords, checkpoint) {
      if (checkpoint === 'from') {
        this.setPlaceFrom(coords)
      } else if (checkpoint === 'to') {
        this.setPlaceTo(coords)
      } else {
        this.setPlaceItem(coords)
      }
    },
    setPlaceFrom(coords) {
      const i = this.markers.findIndex(x => x.infoText === this.$gettext('Origin'))
      if (coords) {
        const marker = {
          id: '0',
          lat: coords[0],
          lng: coords[1],
          icon: this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
          x: 10,
          y: 10,
          infoText: this.$gettext('Origin'),
          tooltip: true
        }
        if (i === -1) {
          this.markers.push(marker)
        } else {
          this.markers[i] = marker
        }
      } else if (i !== -1) {
        this.markers.splice(i, 1)
      }
      this.$refs.fullMap.addMarkers(this.markers)
    },
    setPlaceTo(coords) {
      const i = this.markers.findIndex(x => x.infoText === this.$gettext('Destination'))
      if (coords) {
        const marker = {
          id: '1',
          lat: coords[0],
          lng: coords[1],
          icon: this.$appConfig.staticBaseUrl + 'static/img/ic_destination_on.svg',
          x: 10,
          y: 10,
          infoText: this.$gettext('Destination'),
          tooltip: true
        }
        if (i === -1) {
          this.markers.push(marker)
        } else {
          this.markers[i] = marker
        }
      } else if (i !== -1) {
        this.markers.splice(i, 1)
      }
      this.$refs.fullMap.addMarkers(this.markers)
    },
    setPlaceItem(coords) {
      const i = this.markers.findIndex(x => x.infoText === (this.ecosystemModules.items.label || this.$gettext('Items')))
      if (coords) {
        const marker = {
          id: '2',
          lat: coords[0],
          lng: coords[1],
          icon: {
            type: this.ecosystemModules.items.icon.type,
            size: this.ecosystemModules.items.icon.size,
            anchor: this.ecosystemModules.items.icon.anchor,
            color: '#000'
          },
          x: 10,
          y: 10,
          infoText: this.ecosystemModules.items.label || this.$gettext('Items'),
          tooltip: true
        }
        if (i === -1) {
          this.markers.push(marker)
        } else {
          this.markers[i] = marker
        }
      } else if (i !== -1) {
        this.markers.splice(i, 1)
      }
      this.$refs.fullMap.addMarkers(this.markers)
    }
  }
}
</script>

<style lang="scss" scoped>
#shipping-form {
  position: absolute;
  top: 0;
  left: 160px !important;
  bottom: 0;
  background-color: #ecedef;
  padding: 20px 0 !important;
  border-right: 1px solid #ddd;
  box-shadow: 0 0 15px rgba(0,0,0,.15);
  min-height: calc(100vh - 49px) !important;
  height: calc(100vh - 49px) !important;
  width: 400px !important;
  z-index: 1001;
  overflow-y: auto;
  transition: left .3s ease, left .3s ease;
  .pinned & {
    left: 40px !important;
  }
  .pinned.collapsed & {
    left: 0 !important;
  }
  .alert-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffc107;
    border-width: 0 0 0 5px;
    h5 {
      font-weight: 400;
    }
  }

  .card {
    h4 {
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.6;
      img {
        position: relative;
        vertical-align: top;
      }

    }
  }
  #shipping-form-submit {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 600px;
    border-top: 1px solid #ddd;
    text-align: center;
    background: #fff;
    padding: 30px;
  }
}
#shipping-map {
  padding: 0;
  position: absolute !important;
  top: 0;
  left: 400px !important;
  bottom: 0;
  right: 0 !important;
  width: auto;
  z-index: 1;
  > * {
    height: calc(100vh - 49px) !important;
    min-height: calc(100vh - 49px) !important;
  }
  .vue-map-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto !important;
    height: auto !important;
  }
}
</style>
